import { useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { LockAction } from '../../../../../common/LockAction'
import { Button } from '../../../../../common/html/button'
import { Icon } from '../../../../../common/html/icon'
import { MaxSizeOfItems } from '../../../../../common/maxSizeOfItems'
import { MaxSizeItem } from '../../../../../common/maxSizeOfItems/MaxSizeItem'
import { PopupContactUs } from '../../../../../common/order/popup/popupContactUs'
import EventEmitter, {
  SHOW_ORDER_BUSINESS_CREDIT_REPORT,
  SHOW_POPUP_ERROR,
  SHOW_POPUP_FACTSHEET,
  SHOW_POPUP_FOLLOW_ALERT,
  SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO,
} from '../../../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../../layout/store/slice'
import { MAIN_SCREEN } from '../../../../../tool/dynamicReport/constant'
import PopupKeepSetting from '../../../../../tool/dynamicReport/preferenceSetting/detailTemplate/PopupKeepSetting'
import { COMPANY_TYPES } from '../../../../../utils/common'
import { getMapIconFollowUserType } from '../helper'
import { selectCompanyInfo } from '../store/slice'
import useCheckIsCompanyType from '../useCheckIsCompanyType'
import classes from './index.module.scss'

export const Action = () => {
  const isBlockDynamicReport = useCheckIsCompanyType([
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
  ])

  const userType = useSelector(selectUserType)
  const companyInfo = useSelector(selectCompanyInfo)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const [isOpenContactUs, setIsOpenContactUs] = useState(false)
  const [isShow, setIsShow] = useState(false)

  const mapIconFollowUserType = getMapIconFollowUserType(
    userType,
    companyInfo?.allowDynamicReport,
    () => {
      EventEmitter.dispatch(SHOW_ORDER_BUSINESS_CREDIT_REPORT, true)
    },
    () => {
      setIsShow(true)
    },
    () => {
      EventEmitter.dispatch(SHOW_POPUP_FACTSHEET, true)
    },
    () => {
      EventEmitter.dispatch(SHOW_POPUP_MANAGE_COMPANY_PORTFOLIO, true)
    },
    () => {
      EventEmitter.dispatch(SHOW_POPUP_FOLLOW_ALERT, true)
    },
    AUTHORIZATION_API,
  )

  if (isBlockDynamicReport) {
    mapIconFollowUserType['icon-description'].action = () => {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        title: I18n.t('common.WARNING'),
        messages: [I18n.t('errorCommon.COMPANY_TYPE_ERROR')],
      })
    }
    mapIconFollowUserType['icon-sim-card-download'].action = () => {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        title: I18n.t('common.WARNING'),
        messages: [
          <>
            {I18n.t('errorCommon.COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_1')}
            <span
              onClick={() => {
                setIsOpenContactUs(true)
                EventEmitter.dispatch(SHOW_POPUP_ERROR, null)
              }}
            >
              <Translate
                style={{ color: '#2C73E8' }}
                className="cursorPointer"
                value="errorCommon.COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_2"
              />
            </span>
            {I18n.t('errorCommon.COMPANY_TYPE_ERROR_DOWNLOAD_FACTSHEET_3')}
          </>,
        ],
      })
    }
  }

  return (
    <div className={classes.container}>
      <MaxSizeOfItems>
        {(size, setSizes) => {
          return [
            [
              mapIconFollowUserType['icon-folder-plus'],
              mapIconFollowUserType['icon-sim-card-download'],
            ],
            [
              mapIconFollowUserType['icon-pdf'],
              mapIconFollowUserType['icon-description'],
            ],
          ].map((row, index) => {
            return (
              <div
                key={index}
                className="dFlex"
                style={{ marginTop: 4, gap: 4 }}
              >
                {row.map((item) => {
                  return (
                    <MaxSizeItem
                      key={item.iconClass}
                      keyItem={index + item.iconClass}
                      size={size}
                      setSizes={setSizes}
                    >
                      <LockAction enable={item.isLock}>
                        <Button
                          action={item.isLock ? () => {} : item.action}
                          className={classes.button}
                          style={{
                            backgroundColor: '#FFFFFF',
                            color: '#3a414b',
                            borderColor: '#d1d1d1',
                          }}
                          label={
                            <>
                              <Icon
                                className={item.iconClass}
                                style={{ color: item.color, fontSize: 18 }}
                              />
                              <Translate value={item.label} />
                              {item.isLock && (
                                <Icon
                                  className="icon-lock"
                                  style={{ color: '#9C9C9C', fontSize: 16 }}
                                />
                              )}
                            </>
                          }
                        />
                      </LockAction>
                    </MaxSizeItem>
                  )
                })}
              </div>
            )
          })
        }}
      </MaxSizeOfItems>
      <PopupContactUs
        isOpen={isOpenContactUs}
        onClose={() => setIsOpenContactUs(false)}
      />
      <PopupKeepSetting
        isShow={isShow}
        setIsShow={setIsShow}
        data={{
          organizationId: companyInfo.organizationId,
          companyType: companyInfo.companyType,
          mainScreen: MAIN_SCREEN.COMPANY_ANALYSIS,
        }}
      />
    </div>
  )
}
